import { compose } from 'recompose';
import { withTranslation } from 'react-i18next';

import SummaryRow from './summaryRow';

const enhance = compose(
  withTranslation(['tasks']),
);
export default enhance(SummaryRow);
